import type { StateCreator } from 'zustand';
import type { NicheInfo } from '../types';
import { nichesApi } from '../services/nichesApi';

export interface NichesSlice {
  niches: NicheInfo[];
  nichesLoading: boolean;
  fetchNiches: (lang?: string) => Promise<void>;
  renameNiche: (oldName: string, newName: string) => Promise<void>;
}

export const createNichesSlice: StateCreator<NichesSlice> = (set) => ({
  niches: [],
  nichesLoading: false,

  fetchNiches: async (lang) => {
    set({ nichesLoading: true });
    try {
      const niches = await nichesApi.list(lang);
      set({ niches, nichesLoading: false });
    } catch {
      set({ nichesLoading: false });
    }
  },

  renameNiche: async (oldName, newName) => {
    await nichesApi.rename(oldName, newName);
    set((state) => ({
      niches: state.niches.map((n) =>
        n.name === oldName ? { ...n, name: newName } : n
      ),
    }));
  },
});
